import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import { ModalComponent } from '../../base2';
import {
  AuthUserContext,
  ButtonBar,
  ExecutorList, PersonSelect, ScreenHeader
} from '../../components';
import { ExecutorsContext, ExecutorsProvider } from '../../context';
import { useCreateOrUpdate, useIndex } from '../../hooks';
import { Person } from '../../types';
import { NewBeneficiaryPage } from '../new-beneficiary-page';

import { NewWillContext } from './new-will-provider';

interface Executor extends Person {
  isPrimary: boolean;
  personId: string;
}

export function NewWillExecutorsScreen() {
  return (
    <ExecutorsProvider>
      <NewWillExecutorsScreenContent />
    </ExecutorsProvider>
  );
}

export function NewWillExecutorsScreenContent() {
  const navigate = useNavigate();

  const { user } = useContext(AuthUserContext);
  const { will } = useContext(NewWillContext);
  const { executors } = useContext(ExecutorsContext);

  const { data, update } = useIndex('people', { user_id: user?.id });
  const { handleCreateOrUpdate } = useCreateOrUpdate('executors');

  const [ showModal, setShowModal ] = useState(false);
  const [ selected, setSelected ] = useState<Executor[]>(executors || []);

  const handleBack = useCallback(() => {
    navigate('../debt-forgiveness');
  }, [ navigate ]);

  const handleSave = useCallback(async() => {
    const executors = selected.map((executor, idx) => ({
      will_id: will.id,
      person_id: executor.id,
      is_primary: idx === 0
    }));

    const result = await Promise.all(
      executors.map(
        executor => handleCreateOrUpdate(null, executor)
      )
    );

    console.log('result', result);

    navigate('../review');
  }, [ navigate, handleCreateOrUpdate, will.id, selected ]);

  const handleChange = useCallback(
    person => setSelected([ ...selected, person ]),
    [ selected ]
  );
  
  const handleClickableOption = useCallback(() => {
    setShowModal(true);
  }, []);
  
  const handleSaveCompletion = useCallback(() => {
    setShowModal(false);
    update();
  }, [ update ]);
  
  const handleClose = useCallback(() => {
    setShowModal(false);
  }, []);
  
  const handleRemove = useCallback(
    (executor: Person) => {
      setSelected(selected.filter((p) => p.id !== executor.id));
    },
    [ selected ]
  );
  
  const people = data
    .filter((person) => person.linkedUserId !== user?.id)
    .filter((person) => !selected.map((p) => p.id).includes(person.id));
  
  const options = people.map((person) => ({
    label: `${person.firstName} ${person.lastName}`,
    ...person
  }));

  console.log('Options:', options);
  console.log('Selected executors:', selected);

  return (
    <div className="new-will-executors-screen">
      <ScreenHeader 
        title="Executors"
        description="Select the people who will execute your will and ensure your wishes are carried out."
        handleBack={handleBack} 
        steps={6} 
        step={5}
      />
      
      <PersonSelect
        handleClickableOption={handleClickableOption}
        handleSelect={handleChange}
        options={options}
        selected={{ id: null, firstName: '', lastName: '' }}
      />
      
      <ExecutorList
        executors={selected}
        onRemove={handleRemove}
      />
      
      <ButtonBar
        handlePrimary={handleSave}
        primaryText="Save"
      />
      
      <ModalComponent
        closeModal={handleClose}
        contentStyle={{ height: '70%', width: '96%' }}
        showModal={showModal}
      >
        <NewBeneficiaryPage handleSaveCompletion={handleSaveCompletion} />
      </ModalComponent>
    </div>
  );
}


